export default "__VITE_ASSET__CVmIhB$t__"